<app-header></app-header>

<div class="flex mt-2 h-[calc(100vh-64px)]">

    <app-sidebar optionMenu="11"></app-sidebar>

    <div class="p-12 bg-gray-50 flex-1 overflow-y-auto">
       
        <div class="flex items-center justify-between mb-8">
            <h2 class="text-2xl font-semibold text-gray-800">Artículos en Instagram</h2>
          
            <button (click)="guardarCambios()" 
                    [disabled]="guardando" 
                    class="flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded-lg shadow hover:bg-green-700 transition disabled:opacity-50 disabled:cursor-not-allowed">
              <ng-container *ngIf="!guardando; else loading">
                Guardar cambios
              </ng-container>
              <ng-template #loading>
                <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                </svg>
                Guardando...
              </ng-template>
            </button>
          </div>

        <div class="flex gap-2 mb-6">
            <div class="flex items-center w-full bg-white border rounded-lg shadow-sm px-3">
                <svg class="w-5 h-5 text-gray-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M13.828 10.172a4 4 0 010 5.656l-1.414 1.414a4 4 0 01-5.656-5.656l1.414-1.414" />
                </svg>
                <input [(ngModel)]="nuevaUrl" type="text" placeholder="Pega aquí la URL de la nota de Pulzo"
                    class="w-full py-2 outline-none text-gray-700" />
            </div>
            <button (click)="agregarArticulo()"
                class="bg-purple-purple6 text-white px-4 py-2 rounded-lg shadow hover:bg-purple transition">
                Añadir Nota
            </button>
        </div>

        <div class="mb-8 border-2 border-dashed border-gray-300 rounded-lg p-6 flex flex-col items-center justify-center text-gray-500 hover:bg-gray-100 transition cursor-pointer"
            (click)="fileInput.click()" (drop)="onDrop($event)" (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)">

            <ng-container *ngIf="!previewImage; else preview">
                <svg class="w-12 h-12 mb-2" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M12 12V4m0 0L8 8m4-4l4 4" />
                </svg>
                <p class="text-sm">Arrastra una imagen o haz clic para subir</p>
            </ng-container>

            <ng-template #preview>
                <img [src]="previewImage" class="max-h-40 rounded-lg shadow" alt="Preview" />
            </ng-template>

            <input type="file" #fileInput hidden (change)="onFileSelected($event)" />
        </div>

        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-5">
            <div *ngFor="let articulo of articulos"
                class="bg-white rounded-xl shadow hover:shadow-lg transition p-4 flex flex-col">
                <img [src]="articulo.image || 'assets/no-image.png'" class="rounded-lg mb-4" alt="Artículo" />

                <p class="text-gray-800 font-medium mb-3">{{ articulo.title }}</p>
                <button (click)="eliminarArticulo(articulo.id)"
                    class="self-end flex items-center gap-1 bg-red-100 text-red-600 px-3 py-1 rounded-full hover:bg-red-200 transition">
                    🗑 Eliminar
                </button>
            </div>
        </div>
    </div>
</div>